import React from 'react';
import { ChevronDown } from 'lucide-react';
import { Button } from './ui/button';

const HeroSection = ({ data }) => {
  const scrollToNext = () => {
    // Try to scroll to services section (main content)
    const element = document.getElementById('services');
    if (element) {
      const header = document.querySelector('header');
      const headerHeight = header ? header.offsetHeight : 80;
      const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
      window.scrollTo({
        top: elementPosition - headerHeight - 20,
        behavior: 'smooth'
      });
    }
  };

  const handleCTAClick = () => {
    if (data?.ctaLink) {
      // Check if it's an internal link (starts with # or /)
      if (data.ctaLink.startsWith('#')) {
        const element = document.getElementById(data.ctaLink.substring(1));
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      } else if (data.ctaLink.startsWith('/')) {
        window.location.href = data.ctaLink;
      } else {
        // External link
        window.open(data.ctaLink, '_blank');
      }
    }
  };

  // Separar o título em duas partes se contiver ponto
  const titleParts = data?.title?.split('.') || ["Bem-vindo"];
  const mainTitle = titleParts[0]?.trim() || "Bem-vindo";
  const subTitle = titleParts[1]?.trim() || "";
  
  // Check if we have CTA text and link
  const hasCTA = data?.ctaText && data?.ctaLink;

  return (
    <section className="relative min-h-screen flex items-center justify-center pt-20 overflow-hidden">
      {/* Background - Image or Gradient */}
      {data?.image ? (
        <>
          {/* Background Image */}
          <div 
            className="absolute inset-0 bg-cover bg-center bg-no-repeat"
            style={{ backgroundImage: `url(${data.image})` }}
          />
          {/* Overlay for better text readability */}
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/40" />
        </>
      ) : (
        /* Gradient Background (default) - Soft Background */
        <div className="absolute inset-0 bg-brand-soft" />
      )}

      {/* Content */}
      <div className="container mx-auto px-6 relative z-10">
        <div className="max-w-5xl mx-auto text-center">
          <h1 className={`font-display font-light mb-6 leading-tight tracking-tight ${data?.image ? 'text-white' : 'text-brand-text'}`}>
            <div className="text-5xl md:text-6xl lg:text-7xl mb-3">
              {mainTitle}
            </div>
            {subTitle && (
              <div className={`text-3xl md:text-4xl lg:text-5xl ${data?.image ? 'text-white/90' : 'text-brand-primary'}`}>
                {subTitle}
              </div>
            )}
          </h1>
          <p className={`text-xl md:text-2xl font-body leading-relaxed max-w-4xl mx-auto mb-12 mt-10 ${data?.image ? 'text-white/90' : 'text-brand-text-secondary'}`}>
            {data?.subtitle || "Encontre a propriedade dos seus sonhos"}
          </p>
          
          {/* CTA Button (optional) */}
          {hasCTA && (
            <div className="mb-12">
              <button
                onClick={handleCTAClick}
                className={`inline-block px-8 py-4 text-lg font-body font-medium transition-all duration-300 ${
                  data?.image 
                    ? 'bg-white text-brand-primary hover:bg-brand-accent shadow-xl' 
                    : 'bg-brand-primary text-white hover:bg-brand-primary-hover shadow-lg'
                }`}
              >
                {data.ctaText}
              </button>
            </div>
          )}
          
          {/* Scroll Down Button */}
          <button 
            onClick={scrollToNext}
            className={`inline-flex items-center justify-center w-16 h-16 rounded-full border-2 transition-all duration-300 ${
              data?.image
                ? 'border-white/50 hover:border-white hover:bg-white/10'
                : 'border-brand-accent-hover hover:border-brand-primary hover:bg-white'
            }`}
          >
            <ChevronDown className={`w-6 h-6 ${data?.image ? 'text-white' : 'text-brand-primary'}`} />
          </button>
        </div>
      </div>

      {/* Decorative elements (only show without background image) */}
      {!data?.image && (
        <>
          <div className="absolute top-32 right-12 w-64 h-64 bg-brand-accent/40 rounded-full opacity-30 blur-3xl hidden lg:block"></div>
          <div className="absolute bottom-32 left-12 w-48 h-48 bg-brand-accent/50 rounded-full opacity-30 blur-3xl hidden lg:block"></div>
        </>
      )}
    </section>
  );
};

export default HeroSection;